"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var checkoutLiteMainRoutesContainerStyles = styles_1.makeStyles(function () { return ({
    root: {
        maxWidth: '1200px',
        margin: 'auto',
        width: '100%',
        paddingBottom: 40,
    },
}); }, { name: 'Checkout_checkoutLiteMainRoutesContainer' });
exports.default = checkoutLiteMainRoutesContainerStyles;
